<mat-form-field
    appearance="outline"
    [class.ca-highlight]="highlight"
    [class.mat-form-field-invalid]="isInvalid && isTouched"
    [ngClass]="question | formFieldStyles"
    subscriptSizing="dynamic"
    [hideRequiredMarker]="question.hideRequiredMarker"
    [floatLabel]="question.floatLabel"
    class="ca-form-field ca-text-field-dropdown ca-form-field-w-full"
>
    @if (question.label) {
        <mat-label [attr.for]="question.key">{{ question.label | translate }}</mat-label>
    }
    <input
        matInput
        class="absolute ca-text-field-dropdown-input"
        #inputRef
        [formControl]="textControl"
        [id]="question.key"
        [attr.data-testid]="question.key"
        [mask]="question.mask.pattern"
        [patterns]="$any(question).mask?.customPatterns"
        [decimalMarker]="$any(question).mask?.decimalMarker"
        [separatorLimit]="$any(question).mask?.separatorLimit"
        [dropSpecialCharacters]="($any(question).mask?.dropSpecialCharacters | isNil) ? true : $any(question).mask?.dropSpecialCharacters"
        (focus)="onFocus()"
    />

    <mat-select
        [formControl]="dropdownControl"
        [class]="question.key + '-test'"
        #dropdownRef
        [errorStateMatcher]="matcher"
        [disableOptionCentering]="true"
        [panelClass]="'ca-search-dropdown-panel-class ' + question.dropdownPanelClass"
        (selectionChange)="onDropdownSelect($event)"
    >
        @if (loading) {
            <div class="flex justify-center items-center">
                <ca-spinner [diameter]="24" [text]="'SPINNER.LOADING' | translate"></ca-spinner>
            </div>
        } @else {
            <div #optionsContainerRef>
                @for (option of question.options; track option; let index = $index) {
                    <mat-option [value]="option.key" [attr.data-testid]="question.key + index" [id]="question.key + index">
                        @if (!option.customTemplate) {
                            <span> {{ option.key | translate }}</span>
                        }
                        @if (option.customTemplate) {
                            <ng-template vpViewHost></ng-template>
                        }
                    </mat-option>
                }
            </div>
        }
    </mat-select>
    @if (highlight && !(isInvalid && isTouched)) {
        <ca-icon matSuffix icon="check" class="ca-icon-s-16-p-0-f-16"></ca-icon>
    }
    @if (highlight && !(isInvalid && isTouched)) {
        <mat-hint>{{ question.conditionalHint | translate }}</mat-hint>
    }
    @if (isInvalid && isTouched) {
        <mat-error @slideDown class="ca-subscript relative">
            <ca-form-error-message>
                {{ errorMessage | translate }}
            </ca-form-error-message>
        </mat-error>
    }
</mat-form-field>
